module.exports = __webpack_public_path__ + "media/images/front/robles_factory-ad6b4e036268653919024f3695a21191.webp";